/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_EyebrowInputs */

const es_l7_price_eyebrow = /** @type {(inputs: L7_Price_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una sola comisión`)
};

const gl_l7_price_eyebrow = /** @type {(inputs: L7_Price_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unha soa comisión`)
};

const en_l7_price_eyebrow = /** @type {(inputs: L7_Price_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One commission`)
};

/**
* | output |
* | --- |
* | "One commission" |
*
* @param {L7_Price_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_eyebrow = /** @type {((inputs?: L7_Price_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_eyebrow(inputs)
	if (locale === "en") return en_l7_price_eyebrow(inputs)
	return es_l7_price_eyebrow(inputs)
});